module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj48cGF0aCBkPSJNOSAzaDE2LjVMMzQgMTEuNVYzNWEyIDIgMCAwIDEtMiAySDlhMiAyIDAgMCAxLTItMlY1YTIgMiAwIDAgMSAyLTJ6IiBmaWxsPSIjOThBMkIzIi8+PHBhdGggZD0iTTI1LjUgM3Y2LjVhMiAyIDAgMCAwIDIgMkgzNHoiIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iLjQ1Ii8+PHBhdGggZD0iTTEzIDIxaDE1djJIMTN6TTEzIDI2aDEwdjJIMTN6IiBmaWxsPSIjZmZmIi8+PC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/disk/file.svg
// module id = 1300
// module chunks = 8